import { PlayIcon } from "@heroicons/react/24/solid";
import React from "react";

import { Button, Dialog, Label } from "@fronterahealth/frontera-ui-components";

import { PlayAllVideoMomentsPlaylist } from "@pages/ClientProgramming/ProgrammingGoalVideoMoments/PlayAllVideoMomentsPlaylist";
import { SessionGroup } from "@pages/ClientProgramming/ProgrammingGoalVideoMoments/ProgrammingGoalVideoMoments";
import { useClientProgrammingData } from "@providers/ClientProgrammingProvider";

interface PlayAllVideoMomentsButtonProps {
  groupedVideoSessions: [string, SessionGroup][];

  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export const PlayAllVideoMomentsButton: React.FC<PlayAllVideoMomentsButtonProps> = ({
  groupedVideoSessions,
  isOpen,
  setIsOpen,
}) => {
  const { setCurrentlyPlayingClipID } = useClientProgrammingData();
  const hasVideoClips = groupedVideoSessions.some(
    ([, sessionGroup]) => sessionGroup?.sessions?.length > 0 && sessionGroup?.media?.signedUploadUrl,
  );

  const handleClose = () => {
    setIsOpen(false);
    setCurrentlyPlayingClipID(null);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Button
        className="rounded-md p-1!"
        appearance="secondary"
        disabled={!hasVideoClips}
        onClick={handleOpen}
        text={
          <div className="flex items-center gap-1">
            <PlayIcon className="h-4 w-4" />{" "}
            <Label size="small" className="text-green-700!">
              Play All
            </Label>
          </div>
        }
      />

      <Dialog
        open={isOpen}
        setOpen={(open) => {
          setIsOpen(open);
          if (!open) {
            setCurrentlyPlayingClipID(null);
          }
        }}
        size="4xl"
        showCloseButton={true}
        title="Video Moments Playlist"
        overflowBehavior="auto"
        primaryButton={undefined}
        secondaryButton={undefined}
      >
        <div className="pb-6">
          <PlayAllVideoMomentsPlaylist groupedVideoSessions={groupedVideoSessions} onClose={handleClose} />
        </div>
      </Dialog>
    </>
  );
};
